import type { IByggInfo } from '@klp/bygg/classes/ByggInfo';
import type { IFakturaInput } from '@klp/faktura/classes';
import { Faktura } from '@klp/faktura/classes';
import type { ISak } from '@klp/sak';
import { Sak } from '@klp/sak';

import type { IFrontpageByggInfo } from './FrontpageByggInfo';
import { FrontpageMessage } from './FrontpageMessage';
import type { IFrontpageMessageInput } from './FrontpageMessage';

export interface IFrontpage {
    frontpageMessages: Array<FrontpageMessage>;
    frontpageFaktura: Array<Faktura>;
    frontpageByggInfo: Array<IFrontpageByggInfo>;
    frontpageIssues: Array<Sak>;
    frontpageAvtaler: number;
    frontpageSumUtestaaende: number;
    frontpageSumUtestaaendeForsinket: number;
    frontpageUtestaaendeAntall: number;
}

interface IFrontpageByggInput {
    byggNummer: IByggInfo['byggNummer'];
    navn: IByggInfo['navn'];
}

export interface IFrontpageInput {
    faktura: Array<IFakturaInput>;
    messages: Array<IFrontpageMessageInput>;
    byggInfo: Array<IFrontpageByggInput>;
    issues: Array<ISak>;
    avtaler: number;
    sumUtestaaende: number;
    sumUtestaaendeForsinket: number;
    utestaaendeAntall: number;
}

export class Frontpage implements IFrontpage {
    public static parseObject(obj: IFrontpageInput): Frontpage {
        try {
            return new Frontpage(obj);
        } catch (e) {
            throw new Error(
                `Couldn't parse object: ${JSON.stringify(obj)} ${e}`,
            );
        }
    }

    public frontpageMessages: IFrontpage['frontpageMessages'];
    public frontpageFaktura: IFrontpage['frontpageFaktura'];
    public frontpageByggInfo: IFrontpage['frontpageByggInfo'];
    public frontpageIssues: IFrontpage['frontpageIssues'];
    public frontpageAvtaler: IFrontpage['frontpageAvtaler'];
    public frontpageSumUtestaaende: IFrontpage['frontpageSumUtestaaende'];
    public frontpageSumUtestaaendeForsinket: IFrontpage['frontpageSumUtestaaendeForsinket'];
    public frontpageUtestaaendeAntall: IFrontpage['frontpageUtestaaendeAntall'];

    constructor(obj: IFrontpageInput) {
        this.frontpageMessages = obj.messages.map((message) =>
            FrontpageMessage.parseObject(message),
        );
        this.frontpageFaktura = obj.faktura.map((faktura) =>
            Faktura.parseObject(faktura),
        );
        this.frontpageByggInfo = obj.byggInfo;
        this.frontpageIssues = obj.issues.map((issue) =>
            Sak.parseObject(issue),
        );
        this.frontpageAvtaler = obj.avtaler;
        this.frontpageSumUtestaaende = obj.sumUtestaaende;
        this.frontpageSumUtestaaendeForsinket = obj.sumUtestaaendeForsinket;
        this.frontpageUtestaaendeAntall = obj.utestaaendeAntall;
    }
}
